import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { FormAdapterBase } from '../form-adapter-base';

export class DisableFormControlsAdapter
<T extends FormGroup> extends FormAdapterBase<T, AbstractControl | FormGroup | FormArray> {

    public constructor(
        form: T,
        basePath: string,
    ) {
        super(form, basePath);
    }

    public override apply(): void {
        const form = this.getTargetForm();
        if (form.disabled) {
            return;
        }

        this.getTargetForm().disable();
    }
}
